import { useEffect, useState } from "react";

import { transformDataToSeries } from "./misc/constants";
import useAxios from "@hooks/use-axios";
import { useParams } from "react-router-dom";
import useSearchParams from "@hooks/use-search-params";

const useRevenueReport = () => {
    const { platformId } = useParams();  
    const { axiosInstance, loading, cancelAllRequests } = useAxios({
        base         : "panel",
        initialLoader: true
    });

    const [data, setData] = useState({
        chart: {
            categories: [],
            series    : []
        },
        widgets: {
            total       : 0,
            new         : 0,
            expansion   : 0,
            existing    : 0,
            contractions: 0
        }
    });
    
    const [queryParams, setQueryParams] = useState({});
    const { getSearchParams } = useSearchParams();

    const getRevenueReport = async () => {
        const { data: responseData } = await axiosInstance.get(`/report/${platformId}/revenue`, {
            params: {
                start: getSearchParams("start"),
                end  : getSearchParams("end"),
                ...queryParams
            }
        });

        const chartData = transformDataToSeries(responseData.report);
        setData({
            chart  : chartData,
            widgets: {
                total       : responseData.widget.total,
                new         : responseData.widget.new,
                expansion   : responseData.widget.expansion,
                existing    : responseData.widget.existing,
                contractions: responseData.widget.contractions
            }
        });
        
    };

    useEffect(() => {
        let isActive = true;
        if (isActive) {
            getRevenueReport();
        }
        return () => {
            isActive = false;
            cancelAllRequests();
        };
    }, [queryParams]);

    return {
        loading,
        data,
        setQueryParams,
        getRevenueReport
    };
};

export default useRevenueReport;